<template>
  <transition name="bounce" v-cloak>
    <div class="scroll-btn" @click="onClick" v-if="showScroll">
      <div class="hover hover0"></div>
      <div class="hover hover1"></div>
      <div class="hover hover2"></div>
      <div class="arrow"></div>
      <div class="arrow"></div>
    </div>
  </transition>
</template>


<script>
import { mapState } from "vuex";

export default {
  name: "ScrollBtn",
  data() {
    return {
      showScroll: false,
      timeOut: null
    };
  },
  computed: {
    ...mapState({
      bodyHeight: state => state.bodyHeight
    })
  },
  watch: {
    bodyHeight() {
      this.checkHeight();
    }
  },
  mounted() {
    this.showScroll = false;
    window.addEventListener("scroll", () => {
      if (this.$store.state.lock) {
        this.showScroll = false;
      } else {
        this.showScroll = (window.scrollY + window.innerHeight) < (document.querySelector('.storyline').clientHeight + 80);
      }
    });

    this.loaded = true;
  },
  methods: {
    onClick() {
      setTimeout(() => {
         this.$SmoothScroll(document.body.scrollHeight, 1000);
        }, 300);
    },
    checkHeight() {
      clearTimeout(this.timeOut);

      // console.log('window.innerHeight < document.body.clientHeight: ' + (window.innerHeight < document.body.clientHeight));
      // console.log('window.scrollY: ' + window.scrollY);
      // console.log('window.innerHeight: ' + window.innerHeight);
      // console.log('document.body.clientHeight: ' + document.body.clientHeight);
      //this.$SmoothScroll(1, 0);
      // window.scrollY -= 1;
      // window.scrollY += 1;
      // console.log(window.scrollY);

      this.timeOut = setTimeout(() => {
        this.showScroll = (window.scrollY + window.innerHeight) < (document.querySelector('.storyline').clientHeight + 80);
      }, 250);
    }
  }
};
</script>


<style lang="scss">
.scroll-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  position: fixed;
  bottom: 20px;
  right: 20px;
  border: none;
  color: white;
  background-color: $color-button-scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  // transform: scale(1);
  // opacity: 1;
  user-select: none;
  overflow: hidden;

  &[v-cloak] {
    display: none;
  }

  .hover{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    transform-origin: center center;
    transform: scale(0);
    border-radius: 50%;
  }

  .hover0{
    transition: .2s .0s;
    background-color: $color-button-scroll-hover0;
  }

  .hover1{
    transition: .2s .1s;
    background-color: $color-button-scroll-hover1;
  }

  .hover2{
    transition: .2s .2s;
    background-color: $color-button-scroll-hover2;
  }

  &:hover {
    .hover0, .hover1, .hover2{
      transform: scale(1);
    }
  }

  .arrow {
    height: 20%;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 1px;

    &:before,
    &:after {
      content: "";
      display: block;
      width: 50%;
      height: 20%;
      background-color: white;
    }

    &:before {
      transform: skewY(25deg);
    }

    &:after {
      transform: skewY(-25deg);
    }
  }
}

.bounce-enter-active,
.bounce-leave-active {
  transition: transform 0.32s, opacity 0.32s;
}
.bounce-enter, .bounce-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scale(0.8);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollBtn.vue